<template>
  <div class="page-wrap">
    <!-- 页面标题区 -->
    <div class="store-header">
      <div class="store-header-left">
        <h5>METTA · 商城</h5>
        <h2>商城</h2>
      </div>
      <div class="store-header-right">{{ visibleProductsCount }} 件商品</div>
    </div>
    <!-- 筛选栏 -->
    <div class="filter-bar">
      <div class="filter-tags">
        <button 
          v-for="cat in categories" 
          :key="cat"
          class="filter-tag"
          :class="{ active: currentCategory === cat }"
          @click="filterProducts(cat)"
        >
          {{ cat }}
        </button>
      </div>
    </div>
    <!-- 商品网格 -->
    <ProductGrid
      :img-url-prefix="imgUrlPrefix"
      :categories="categories"
      :category-labels="categoryLabels"
      :products="products"
      :current-category="currentCategory"
    />
    <!-- 底部CTA -->
    <footer class="footer-cta">
      <h2 class="footer-heading fade-up">METTA 商城</h2>
      <p class="footer-body fade-up" style="transition-delay:.06s">
        每一件产品，都是越野文化的延伸。<br>探索全系，找到属于你的那一款。
      </p>
      <div class="footer-btns fade-up" style="transition-delay:.12s">
        <button class="btn-outline-white" @click="$router.push({ name: 'MettaCommunity' })">加入社区 →</button>
      </div>
      <!-- <div class="footer-copy fade-up" style="transition-delay:.18s">
        METTA · 麦塔 © 2026 &nbsp;·&nbsp; 渠道 &nbsp;·&nbsp; 社区 &nbsp;·&nbsp; 商城 &nbsp;·&nbsp; 载具库
      </div> -->
    </footer>
  </div>
</template>

<script>
import ProductGrid from '../components/store/ProductGrid.vue'
import { fadeAnimate, destroyFadeAnimate } from '../utils/animation.js'
export default {
  components: {
    ProductGrid,
  },
  computed: {
    visibleProductsCount() {
      if (this.currentCategory === '全部') {
        return this.products.length;
      }
      return this.products.filter(p => p.category === this.currentCategory).length;
    }
  },
  mounted() {
    fadeAnimate();
  },
  beforeDestroy() {
    destroyFadeAnimate();
  },
  data() {
    return {
      imgUrlPrefix: '/assets/images/store/', // 图片地址前缀
      // 商品数据
      products: [
        // 车
        { id:'car-metta',        name:'METTA',          category:'车', price:'¥ 189,900', tag:'', img:'car-metta.jpg'       },
        { id:'car-badanjilin',   name:'METTA 巴丹吉林',  category:'车', price:'¥ 219,900', tag:'', img:'car-badanjilin.jpg'  },

        // 后装件
        { id:'addon-taillamp',   name:'尾灯罩',              category:'后装件',   price:'',  tag:'',          img:'addon-taillamp.jpg'   },
        { id:'addon-spoiler',    name:'顶翼',                category:'后装件',   price:'',  tag:'',          img:'addon-spoiler.jpg'    },
        { id:'addon-ladder',     name:'后爬梯',              category:'后装件',   price:'',  tag:'',          img:'addon-ladder.jpg'     },
        { id:'addon-driveshaft', name:'传动轴',              category:'后装件',   price:'',  tag:'',          img:'addon-driveshaft.jpg' },

        // 车衣
        { id:'wrap-tpu',         name:'星辉银 TPU 车衣',     category:'车衣',     price:'',  tag:'',          img:'wrap-tpu.jpg'         },
        { id:'wrap-decal',       name:'METTA 车身拉花',      category:'车衣',     price:'',  tag:'',          img:'wrap-decal.jpg'       },

        // 轮胎轮毂
        { id:'tire-ko3',         name:'百路驰 KO3 轮胎',     category:'轮胎轮毂', price:'',  tag:'',          img:'tire-ko3.jpg'          },
        { id:'wheel-17',         name:'METTA 轮毂 17寸',     category:'轮胎轮毂', price:'',  tag:'',          img:'wheel-17.jpg'         },

        // 服装
        { id:'cap-metta',        name:'METTA 鸭舌帽',        category:'服装',     price:'',  tag:'',          img:'cap-metta.jpg'        },
        { id:'tee-metta',        name:'METTA T恤',           category:'服装',     price:'',  tag:'',          img:'tee-metta.jpg'        },
        { id:'jacket-skin',      name:'METTA 皮肤衣',        category:'服装',     price:'',  tag:'',          img:'jacket-skin.jpg'      },
      ],
      categories: ['全部', '车', '后装件', '车衣', '轮胎轮毂', '服装'],
      categoryLabels: {
        '全部': '全部',
        '车': '车',
        '后装件': '后装件',
        '车衣': '车衣',
        '轮胎轮毂': '轮胎轮毂',
        '服装': '服装',
      },
      currentCategory: '全部',
    }
  },
  methods: {
    // 处理筛选变化
    filterProducts(cat) {
      this.currentCategory = cat;
      fadeAnimate();
    },
    // 更新可见商品数量
    updateVisibleCount(count) {
      this.visibleCount = count;
    },
  },
}
</script>

<style lang="less" scoped>
.page-wrap {
  .store-header {
    padding: 28px 44px 48px;
    border-bottom: 1px solid @bdr;
    display: flex;
    align-items: flex-end;
    justify-content: space-between;
    .store-header-left {
      h5 {
        font-size:9px;
        letter-spacing:4px;
        text-transform:uppercase;
        color:@mute;
        margin-bottom:16px;
      }
      h2 {
        font-size:52px;
        font-weight:100;
        letter-spacing:-2px;
        color:@ink;
        line-height:1;
      }

    }
    .store-header-right {
      font-family:'Roboto Mono',monospace;
      font-size:10px;
      letter-spacing:2px;
      color:@mute;
      padding-bottom:8px;
    }
  }

  .filter-bar {
    position: sticky;
    top: 52px;
    z-index: 88;
    background: rgba(255,255,255,0.92);
    backdrop-filter: blur(12px);
    -webkit-backdrop-filter: blur(12px);
    border-bottom: 1px solid @bdr;
    padding: 16px 44px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    .filter-tags {
      display: flex;
      gap: 6px;
      flex-wrap: wrap;
      .filter-tag {
        font-size: 11px;
        letter-spacing: 0.5px;
        padding: 6px 14px;
        border: 1px solid @bdr;
        color: @mid;
        background: transparent;
        cursor: pointer;
        font-family: inherit;
        font-weight: 300;
        transition: background 0.15s, color 0.15s, border-color 0.15s;
        white-space: nowrap;
        &:hover {
          border-color: @ink;
          color: @ink;
        }
        &.active {
          background: @ink;
          color: #fff;
          border-color: @ink;
        }
      }
    }
  }
  .footer-cta {
    background: #080808;
    padding: 80px 44px;
    text-align: center;
    margin-top: 80px;
    .footer-heading {
      font-size: 32px;
      font-weight: 100;
      color: #ffffff;
      letter-spacing: -1px;
      margin-bottom: 16px;
    }
    .footer-body {
      font-size: 13px;
      color: rgba(255,255,255,0.4);
      max-width: 440px;
      margin: 0 auto 36px;
      line-height: 2;
    }
    .footer-btns {
      display: flex;
      gap: 16px;
      justify-content: center;
      flex-wrap: wrap;
      margin-bottom: 64px;
      .btn-outline-white {
        background-color: #ffffff;
        color: #080808;
        padding: 14px 40px;
        font-size: 9px;
        letter-spacing: 2px;
        text-transform: uppercase;
        cursor: pointer;
        font-family: inherit;
        font-weight: 300;
      }
    }
    .footer-copy {
      font-size: 9px;
      letter-spacing: 2px;
      text-transform: uppercase;
      color: rgba(255,255,255,0.2);
      font-family: 'Roboto Mono', monospace;
      font-weight: 300;
    }
  }
}
@media screen and (max-width: 768px) {
  .page-wrap {
    overflow-x: hidden;

    .store-header {
      padding: 80px 24px 32px;
      display: block;
      border-bottom: 1px solid @bdr;

      .store-header-left {
        h5 {
          font-size: 8px;
          letter-spacing: 4px;
          margin-bottom: 12px;
          font-family: 'Roboto Mono', monospace;
        }

        h2 {
          font-size: 40px;
          font-weight: 100;
          letter-spacing: -1.5px;
          line-height: 1;
          margin-bottom: 8px;
        }
      }

      .store-header-right {
        font-family: 'Roboto Mono', monospace;
        font-size: 9px;
        letter-spacing: 2px;
        padding-bottom: 0;
      }
    }

    .filter-bar {
      top: 52px;
      padding: 12px 0;
      display: block;
      background: rgba(255, 255, 255, 0.94);

      .filter-tags {
        display: flex;
        gap: 6px;
        overflow-x: auto;
        flex-wrap: nowrap;
        padding: 0 24px;
        scrollbar-width: none;
        -webkit-overflow-scrolling: touch;

        &::-webkit-scrollbar {
          display: none;
        }

        .filter-tag {
          flex-shrink: 0;
          font-size: 10px;
          padding: 6px 14px;
          white-space: nowrap;
        }
      }
    }

    .footer-cta {
      padding: 56px 24px;
      margin-top: 48px;

      .footer-heading {
        font-size: 28px;
        line-height: 1.1;
        margin-bottom: 14px;
      }

      .footer-body {
        font-size: 12px;
        line-height: 2;
        max-width: 280px;
        margin-bottom: 28px;
      }

      .footer-btns {
        margin-bottom: 0;

        .btn-outline-white {
          padding: 12px 32px;
          font-size: 9px;
        }
      }
    }
  }
}

</style>